import instance from "../utils/request.js";
export default {
  data() {
    return {
      //   isuserlevel: false,
      //   默认全部都是会员
      isuserlevel: true,
      islogin: false,
      isMobile: false,
    };
  },
  mounted() {
    if (localStorage.getItem("token")) {
      this.islogin = true;
      let userinfo = JSON.parse(localStorage.getItem("user"));
      if (userinfo.vip.id != 1) {
        this.isuserlevel = true;
      }
    }
    this.isMobile = localStorage.getItem("isMobile") == "null" ? false : true;
  },
  methods: {
    $get(url, params) {
      return instance.get(url, {
        params,
      });
    },
    $post(url, data) {
      return instance.post(url, data);
    },
    $put(url, data) {
      return instance.put(url, data);
    },
    $del(url, data) {
      return instance.delete(url, data);
    },
  },
};
